/* --------------------------------------------------
Import moduels
-------------------------------------------------- */

import CanvasParallaxController from 'canvas-parallax';

/* --------------------------------------------------
Document Setup
-------------------------------------------------- */

// Loop all the parallax sections
[...document.querySelectorAll('[data-parallax]')].forEach(section => {
  // Find the image
  const image = section.querySelector('[data-parallax-watch]');

  // If there is no image, return
  if (!image || image.src === '') return;

  // The image's focus position
  const focus = image.getAttribute('data-parallax-watch') || '50% 50%';

  // Create a new ParallaxController
  const Parallax = new CanvasParallaxController({
    depth: Math.floor(window.innerHeight / 3)
  });

  // Load the image
  Parallax.load(image.src, focus);

  // Append the canvas to the section
  section.appendChild(Parallax.canvas.element);
});

// /* --------------------------------------------------
// Import modules
// -------------------------------------------------- */

// import MagicScrolls from 'magic-scrolls';

// /* --------------------------------------------------
// Parallax
// -------------------------------------------------- */

// [...document.querySelectorAll('[data-parallax]')].forEach((section) => {
//   // Create a new MagicScrolls
//   const magic = new MagicScrolls(section, { duration: 600 });
//   // Find the parallax items
//   const items = section.querySelectorAll('[data-parallax-watch]');
//   // Loop through the items and add the parallax effect
//   for (let index = 0; index < items.length; index++) magic.parallax(items[index]);
// });

// /* --------------------------------------------------
// Import modules
// -------------------------------------------------- */

// import { each } from 'meteora';
// import MagicScrolls from 'magic-scrolls';

// /* --------------------------------------------------
// Parallax
// -------------------------------------------------- */

// each('[data-parallax]', (section) => {
//   // Create a new MagicScrolls
//   const magic = new MagicScrolls(section, { duration: 600 });
//   // Find the parallax items
//   const items = section.querySelectorAll('[data-parallax-watch]');
//   // Loop through the items and add the parallax effect
//   for (let index = 0; index < items.length; index++) magic.parallax(items[index]);
// });